import { t } from "i18next";

import { LocalData } from "../../../General/LocalData";
import { NotificationData } from "../NotificationData";

export class NotificationNewChatData extends NotificationData {
  chatID: string = "";
  senderName: string = "";
  message: string = "";
  senderID: string = "";

  setup(data: any) {
    super.setup(data);
    this.type = NotificationData.types.NEW_CHAT;

    if (data.notificationData) {
      this.chatID = data.notificationData?.chatID ?? "";
      this.senderName = data.notificationData?.senderName ?? "";
      this.message = typeof data.notificationData?.message === "string" ? data.message : "";
      this.senderID = data.notificationData?.senderID ?? "";

      this.title = `${this.senderName} ${t("main.chatNotification_hasStartedAChat")}`;
      this.body = this.message;
      this.redirectPath = `/chat?chatId=${this.chatID}`;

      this.userForImageView = LocalData.users.addData(this.senderID);
    }
  }
}
